RivalIQ.module('extensions.Function', function (module, App, Backbone, Marionette, $, _, Function) {

    'use strict';

    /**
     * The map of methods to extend the prototype.
     * @type {{}}
     */
    const extensions = {};

    /**
     * Binds a function to a given context with optional arguments.
     * @returns {*}
     */
    extensions.bind = function () {

        const me = this;
        const args = Array.prototype.slice.call(arguments);
        return _.bind.apply(_, [me].concat(args));
    };

    // NOTE we iterate over the extensions that we've defined and only extend
    // the prototype if the function does not exist already; this is intended
    // to allow native definitions to remain if defined already (e.g., in the
    // case of bind above we only want to add the method when the browser does
    // not support it already)
    _.each(extensions, function (value, key) {

        const prototype = Function.prototype;

        if (!_.isFunction(prototype[key])) {

            prototype[key] = value;
        }
    });

}, window.Function);
